export const iconFeatures = [
    {
        iconClass: "icon-shipping",
        title: "Free Shipping",
        description: "Enjoy free shipping on all orders",
    },
    {
        iconClass: "icon-return",
        title: "Free Returns",
        description: "Within 14 days for a return",
    },
    {
        iconClass: "icon-support",
        title: "Support Online",
        description: "We support customers 24/7",
    },
];

export const iconBoxes = [
    {
        title: "Free shipping for order over $100",
        justify: "justify-content-sm-start",
    },
    { title: "Free return in 14 days", justify: "justify-content-center" },
    { title: "Payment secured", justify: "justify-content-center" },
];

export const dataFeatures = [
    {
        imgSrc: "/images/section/icon-quality.svg",
        bgClass: "bg-light-purple-10",
        title: "Quality Products",
        description: "Only the freshest ingredients for your table.",
        wowDelay: "0s",
    },
    {
        imgSrc: "/images/section/icon-shop.svg",
        bgClass: "bg-light-blue-4",
        title: "Convenient Shopping",
        description: "Easy and quick delivery straight to your door.",
        wowDelay: ".1s",
    },
    {
        imgSrc: "/images/section/icon-prices.svg",
        bgClass: "bg-pink-4",
        title: "Affordable Prices",
        description: "Great value on all your daily essentials.",
        wowDelay: ".2s",
    },
];

export const features2 = [
    {
        icon: "icon-precision",
        title: "Precision in Every Stitch",
        description:
            "At Vineta, we use only premium materials, ensuring our collections offer superior comfort and lasting durability. Every piece is crafted with care and attention to detail.",
    },
    {
        icon: "icon-elegance",
        title: "Effortless Elegance",
        description:
            "Our designs embrace simplicity at its finest. Vineta’s understated yet refined style captures the essence of modern fashion, making a statement.",
    },
    {
        icon: "icon-fashion-body",
        title: "Fashion for Every Body",
        description:
            "We celebrate individuality with a diverse range of sizes, offering clothing that fits and flatters every body type. At Vineta, fashion is for everyone.",
    },
];
